module.exports = __webpack_public_path__ + "static/media/proj3.8c9c95dd.jpg";